import {DataContentWrapper} from '@hconnect/common/containers'
import {CardBox} from '@hconnect/uikit/src/lib2'
import {Box, Stack, Typography} from '@mui/material'
import {orderBy} from 'lodash'
import {useTranslation} from 'react-i18next'

import {DowntimeByCategoryBarChart} from '../components'
import {DOWNTIME_ANALYTICS_WIDGET_NAMESPACE} from '../consts'
import {useStoppagesCategoryTypeCounts} from '../hooks'
import {StoppageCategoryCounts} from '../types'

type StoppageCategoryCountsChartContainerProps = {
  plantId: string
  from: Date
  to: Date
}

const orderByYear = (data: StoppageCategoryCounts[] | undefined) => orderBy(data, 'year')

export const StoppageCategoryCountsChartContainer = ({
  plantId,
  from,
  to
}: StoppageCategoryCountsChartContainerProps) => {
  const {t} = useTranslation(DOWNTIME_ANALYTICS_WIDGET_NAMESPACE)

  const {
    data = [],
    isError,
    isLoading,
    refetch,
    isRefetching
  } = useStoppagesCategoryTypeCounts(
    {plantId, from: from.toISOString(), to: to.toISOString()},
    {select: orderByYear}
  )

  return (
    <CardBox sx={{height: '100%', display: 'flex', flexDirection: 'column', minHeight: 400}}>
      <Stack sx={{mb: 2}}>
        <Typography variant="h3">{t('stoppageCategoryCountsChart.cardTitle')}</Typography>
        <Typography variant="caption">{t('stoppageCategoryCountsChart.cardSubtitle')}</Typography>
      </Stack>
      <DataContentWrapper
        showLoader={isLoading}
        data={data}
        retryFunction={() => void refetch()}
        isError={isError}
        isRefetching={isRefetching}
        progressSx={{color: 'primary.main'}}
      >
        <Box sx={{flex: 1, display: 'flex'}}>
          <DowntimeByCategoryBarChart data={data} />
        </Box>
      </DataContentWrapper>
    </CardBox>
  )
}
